import React, { useCallback, useEffect, useState } from 'react';
import DefaultScreenContainer from '~/components/DefaultScreenContainer';
import Cards from './components/Cards';
import Header from './components/Header';
import BannersCarousel from './components/BannersCarousel';
// import News from './components/News';
import AllServices from './components/AllServices';
import MyServices from './components/MyServices';
import { useUserInfoStore } from '~/stores/userInfo';
import { RefreshControl } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { GetBannersUseCase } from '~/useCases/Home/GetBannersUseBase';

const Home: React.FC = () => {
  const [initLoading, setInitLoading] = useState(true);
  const [banners, setBanners] = useState<Banner.Platform>();

  const { user, loading } = useUserInfoStore();

  useFocusEffect(
    useCallback(() => {
      useUserInfoStore.getState().loadContractedServices({ noLoading: true });
    }, [])
  );

  useEffect(() => {
    async function load() {
      setInitLoading(true);
      try {
        setBanners(await GetBannersUseCase());
      } finally {
        setInitLoading(false);
      }
    }
    load();
  }, []);

  return (
    <DefaultScreenContainer
      refreshControl={
        <RefreshControl
          refreshing={loading}
          onRefresh={useUserInfoStore.getState().loadContractedServices}
        />
      }
    >
      <Header />

      <BannersCarousel isLoading={initLoading} banners={banners} />

      {/* <News /> */}

      <Cards />

      {!MarisaAppUtils.disableInsurance && (
        <MyServices data={user?.contractedServices} />
      )}

      <AllServices />
    </DefaultScreenContainer>
  );
};

export default Home;
